import React from 'react';

import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

export const RequireAdmin = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <div>Загрузка...</div>;
    if (!user || !user.is_admin) return <Navigate to="/" replace />;

    return children;
};